var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConsignee(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 30,
    viewBox: "0 0 47 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M23.38 49.41a.47.47 0 0 1-.28-.09L.21 33.47a.52.52 0 0 1-.21-.41V17.2a.5.5 0 0 1 .27-.44.49.49 0 0 1 .51 0l22.89 15.82a.51.51 0 0 1 .21.41v15.92a.49.49 0 0 1-.27.44.46.46 0 0 1-.23.06zM1 32.79L22.88 48V33.26L1 18.15v14.64z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.38 49.41a.5.5 0 0 1-.29-.91L45.2 32.74V18.17L23.67 33.4a.5.5 0 0 1-.7-.12.51.51 0 0 1 .12-.7l22.33-15.79a.49.49 0 0 1 .51 0 .49.49 0 0 1 .27.44V33a.48.48 0 0 1-.21.41L23.67 49.32a.52.52 0 0 1-.29.09z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.5 17.7a.49.49 0 0 1-.4-.2.49.49 0 0 1 .11-.7L23.09.1a.49.49 0 0 1 .59 0L46 16.8a.5.5 0 0 1-.6.8l-22-16.48L.79 17.61a.5.5 0 0 1-.29.09z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M18.88 42a.53.53 0 0 1-.29-.1L3.41 30.76a.52.52 0 0 1-.21-.4v-6.05a.52.52 0 0 1 .27-.44.51.51 0 0 1 .52 0l15.18 10.59a.49.49 0 0 1 .21.41v6.62a.48.48 0 0 1-.27.44.46.46 0 0 1-.23.07zM4.2 30.1l14.18 10.4v-5.37L4.2 25.27v4.83z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.82 26.2a.5.5 0 0 1-.4-.19.51.51 0 0 1 .09-.7L34.24 8.46a.5.5 0 0 1 .7.08.51.51 0 0 1-.09.71L13.13 26.1a.5.5 0 0 1-.31.1zM33.11 37.1a.5.5 0 0 1-.35-.14l-3.08-3a.5.5 0 0 1 0-.71.48.48 0 0 1 .7 0L33 35.81l7-11a.51.51 0 0 1 .69-.16.49.49 0 0 1 .16.69l-7.32 11.52a.49.49 0 0 1-.36.23l-.06.01z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsignee);
export default __webpack_public_path__ + "static/media/consignee.cfe5eeacac4449642b4403faea00007d.svg";
export { ForwardRef as ReactComponent };